import React from 'react';
import '../../../css/login.css';
import {LocalForm} from 'react-redux-form';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {submitBackupCodesChallenge} from '../../actions/actions';

/**
 * @author octopaas
 * @since May-2018
 */
class TotpBackupCodes extends React.Component {

    constructor(props) {
        super(props);
        this.state = {totpCodesDownloaded: false};
        this.codesDownloaded = this.codesDownloaded.bind(this);
    }

    codesDownloaded() {
        this.setState({ totpCodesDownloaded: true });
    };

    render() {

        const {title, backupCodes, downloadTotpBackupCodesLabel, backupCodeFileName, submitLabel, confirmBackupCodes, token, challenge} = this.props;

        const backupCodesList = backupCodes.split(',');
        const backupCodesHtmlLeft = backupCodesList.slice(0,3).map((code, i) =>
            <li key={i}>{code}</li>
        );
        const backupCodesHtmlRight = backupCodesList.slice(3).map((code, i) =>
            <li key={i}>{code}</li>
        );
        const downloadTotpTextFile = <a className="op-link" href={"data:text/plain;charset=utf-8," + backupCodesList}
                                        download={backupCodeFileName} onClick={this.codesDownloaded}>{downloadTotpBackupCodesLabel}</a>;

        return (
            <div key="TotpBackupCodes_1">
                <LocalForm model="loginForm" className="login-form" onSubmit={()=>confirmBackupCodes(token, challenge)}>
                    <h4 className="informative-title">{title}</h4>
                    <div className="wdc-row message resend-link-message">
                        <div className="wdc-col-md-6"><ul className="backup-codes">{backupCodesHtmlLeft}</ul></div>
                        <div className="wdc-col-md-6"><ul className="backup-codes">{backupCodesHtmlRight}</ul></div>
                    </div>
                    <div className="download-link">{downloadTotpTextFile}</div>
                    <button className="wdc-btn wdc-btn-primary" disabled={!this.state.totpCodesDownloaded}>{submitLabel}</button>
                </LocalForm>
            </div>
        );
    }
}

TotpBackupCodes.propTypes = {
    title: PropTypes.string,
    backupCodes: PropTypes.string,
    backupCodeLinkInfo: PropTypes.string,
    submitLabel: PropTypes.string,
    token: PropTypes.string,
    challenge: PropTypes.string,
    confirmBackupCodes: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
      token: state.login.token,
      title: state.login.challengeResponse.title,
      backupCodes: state.login.challengeResponse.prompts.backupCodes.value,
      downloadTotpBackupCodesLabel: state.login.challengeResponse.prompts.backupCodeLinkInfo.label,
      backupCodeFileName: state.login.challengeResponse.prompts.backupCodeLinkInfo.value,
      submitLabel: state.login.challengeResponse.submitLabel,
      challenge: state.login.challengeResponse.nextChallenge
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirmBackupCodes: (token, challenge) => {
            dispatch(submitBackupCodesChallenge(token, challenge));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TotpBackupCodes);
